import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
//import { Button, Form, Alert } from "react-bootstrap";
//import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Card from 'react-bootstrap/Card';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@material-ui/core/CardContent';
//import CardHeader from '@material-ui/core/CardHeader';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner'
import { makeStyles } from '@material-ui/core/styles';
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";
import SuperResellerClientTransactions from './SuperResellerClientTransactions';
import ResellerPassword from './ResellerPassword';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    header: {
        //textAlign: 'center',
        spacing: 2
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,

    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));


function AdminUpdateDealer(props){

    const [dealer, setDealer] = useState(
        props.currentDealer
    );
    const [transaction, setTransaction] = useState(0);

    const [credits, setCredits] = useState(1);
    //const currentDescription = useSelector((state) => state.reseller.item.description);
    const [description, setDescription] = useState("");
    const [reseller, setReseller] = useState(0);
    const [resellersList, setResellersList] = useState([]);
    //const [dealerTransactions, setDealerTransactions] = useState()
    const dealerSelector = useSelector((state) => state.dealer.name);
    const paperStyle = {padding: 16};

    const classes = useStyles();

    useEffect(() => {
        //props.onInitializeSaveClient();
        props.onInitializeSaveDealer();
        props.onGetDealer(props.token, props.currentDealerName);
        props.onGetShortResellerList(props.token);
        console.log('logging description', description);

    }, []);

    //useEffect(() => {
    //    if (props.resellers && props.resellers.length){
    //        setResellersList(props.resellers);
    //        setReseller(props.currentResellerName);
    //    }
    //},[]);

    useEffect(() => {
        if (props.resellers && props.resellers.length){
            console.log('inside resellers list', props.resellers);
            setResellersList(props.resellers);
            setReseller(props.currentResellerName);
        }
    },[props.resellers]);

    useEffect(() => {
        console.log('inside useEffect currentreseller state change', props.currentDealer);
        //console.log('useEffect currentreseller length', props.currentReseller.length);
        //if (props.currentReseller && props.currentReseller.length){
        setDealer(props.currentDealer);
        console.log('current dealer object', dealer);
        setDescription(props.currentDealer.description);
        console.log('logging description', description);
        //}
    }, [props.currentDealer]);

    useEffect(() => {
        if (props.isErrorSaveDealer){
            var errorMessage = '' + props.isErrorSaveDealer;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isErrorSaveDealer]);

    const handleChange = (event) => {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        console.log('name', name);
        console.log('value', value);
        const key = target.key;
        setReseller({
            ...reseller,
            [name]: value
        })
    };

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    let options = [...Array(100).keys()].slice(1);
    options = [...options, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];

    function handleSubmitCredits(event) {
        event.preventDefault();

        const data = {
            name: dealer.name,
            credits: credits,
            transaction: transaction

        };
        console.log('logging data', data);
        props.onUpdateDealerCredits(props.token, data);

    }

    function handleEditDealer(event) {
        event.preventDefault();

        const data = {
            name: props.currentDealer.name,
            reseller: reseller,
            description: description
        };
        console.log('logging data', data);
        if (reseller === 0){
            var errorMessage = 'Please select a reseller';
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        } else {
            props.onUpdateDealerAdmin(props.token, data);
        }
    }

    let saveDealerRedirect = null;
    if(props.isSuccessSaveDealer){
        console.log('redirecting because', props.isSuccessSaveDealer);
        //props.onGetCredits(props.token);
        var successMessage = 'Updated ' + props.isSuccessSaveDealer.name;
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
        saveDealerRedirect = <Redirect to="/managedealers" />
    }

    // let displayError = null;
    // if (props.isErrorSaveReseller){
    //     //displayError = <Alert variant="danger">{props.isErrorSaveReseller}</Alert>
    //     var errorMessage = '' + props.isErrorSaveReseller;
    //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
    // }

    //<FormGroup>
    //    <FormControl className={classes.formControl}>
    //        <TextField
    //            id="description"
    //            name="description"
    //            value={reseller.description}
    //            label="Description"
    //            onChange={handleChange}
    //            type="text"
    //        />
    //    </FormControl>
    //</FormGroup>
    //
    ////onChange={e => setDescription(e.target.value)}
    return (
        <div>
            {saveDealerRedirect}
            <Container>
                <Grid container spacing={2}>
                    <Grid item sm={12}>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={4} xs={12}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Credits"
                                            subheader={props.currentDealer.name + ', ' + props.currentDealer.credits + ' Credits'}
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                            subheaderTypographyProps={{
                                                fontSize: 14,
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent>
                                            <form>
                                                <FormGroup row>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="select-transactions-label">Select Transaction</InputLabel>
                                                        <Select
                                                            id="transaction"
                                                            labelId="Transaction"
                                                            onChange={e => setTransaction(e.target.value)}
                                                            value={transaction}
                                                        >
                                                            <MenuItem key={0} value={0}>Add</MenuItem>
                                                            <MenuItem key={0} value={1}>Remove</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </FormGroup>
                                                <FormControl fullWidth>
                                                    <InputLabel id="select-credits-label">Credits</InputLabel>
                                                    <Select
                                                        id="credits"
                                                        labelId="Credits"
                                                        onChange={e => setCredits(e.target.value)}
                                                        value={credits}
                                                    >
                                                        {options.map(option => {
                                                            return <MenuItem key={option} value={option}>{option}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>

                                            </form>
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                block
                                                disabled={props.isLoadingSaveDealer}
                                                type="submit"
                                                onClick={handleSubmitCredits}
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                fullWidth
                                            >
                                                {props.isLoadingSaveDealer
                                                    ? spinner
                                                    : 'Submit'}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Paper>
                            </Grid>
                            <Grid item sm={4} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <ResellerPassword role="admin" login={dealerSelector}/>
                                </Paper>
                            </Grid>
                            <Grid item sm={4} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Edit Reseller"
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent>
                                            <form>
                                                <FormGroup row>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="select-super-reseller-label">Select Reseller</InputLabel>
                                                        <Select
                                                            id="reseller"
                                                            labelId="Select Reseller"
                                                            onChange={e => setReseller(e.target.value)}
                                                            value={reseller}
                                                        >
                                                            <MenuItem value={0}>Select Reseller</MenuItem>
                                                            {resellersList.map(item => {
                                                                return <MenuItem key={item.reseller} value={item.reseller}>{item.reseller}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <TextField
                                                        id="description"
                                                        name="description"
                                                        value={description}
                                                        label="Description"
                                                        onChange={e => setDescription(e.target.value)}
                                                        type="text"
                                                        fullWidth
                                                    />
                                                </FormGroup>
                                            </form>
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                block
                                                disabled={props.isLoadingSaveDealer}
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                fullWidth
                                                onClick={handleEditDealer}
                                            >
                                                {props.isLoadingSaveDealer
                                                    ? spinner
                                                    : 'Update'}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Transaction History"
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent><SuperResellerClientTransactions role="admin" login={dealerSelector}/></CardContent>
                                    </Card>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )

}

const mapDispatchToProps = dispatch => {
    return {
        onGetDealer: (token, name) => dispatch(actions.getDealerAdmin(token, name)),
        onInitializeSaveDealer: () => dispatch(actions.initializeSaveDealer()),
        onSaveDealer: (token, data) => dispatch(actions.saveDealer(token, data)),
        onUpdateDealerCredits: (token, data) => dispatch(actions.updateDealerCreditsAdmin(token, data)),
        onUpdateDealerAdmin: (token, data) => dispatch(actions.updateDealerAdmin(token, data)),
        onGetShortResellerList: (token) => dispatch(actions.resellerListShortAdmin(token)),
        //onGetCredits: (token) => dispatch(actions.creditsSuperReseller(token)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        currentDealerName: state.dealer.name,
        currentResellerName: state.reseller.name,
        currentDealer: state.dealer.item,
        isLoadingDealer: state.dealer.loading,
        isErrorSaveDealer: state.saveDealer.error,
        isSuccessSaveDealer: state.saveDealer.dealer,
        isLoadingSaveDealer: state.saveDealer.loading,
        resellers: state.resellers.reseller_list

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminUpdateDealer);